import { render } from "./OpenHead.vue?vue&type=template&id=b8a6464a&scoped=true&ts=true"
import script from "./OpenHead.vue?vue&type=script&lang=ts"
export * from "./OpenHead.vue?vue&type=script&lang=ts"

import "./OpenHead.vue?vue&type=style&index=0&id=b8a6464a&scoped=true&lang=css"

import exportComponent from "/home/lahiru-dhananjaya/Documents/Jeewaka/PMS/Source and Documentation/pharma-connect2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8a6464a"]])

export default __exports__